import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import {
  Row,
  Card,
  CardBody,
  Input,
  CardTitle,
  FormGroup,
  Form,
  Button,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
  CardHeader,
  Label,
  ModalHeader,
  Col,
} from "reactstrap";
import Pagination from "../../../containers/pages/Pagination";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import { useHistory } from "react-router-dom";
import {
  getLocationService,
  addLocations,
  updateLocationService,
  deleteLocationContactService,
  getLocationContactNotes,
  addJobNotes,
  addLocationNotes,
  deleteLocationContactNotes,
} from "../../../services/AccountService";
import { isNullOrEmpty } from "../../../config/ENV";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CgNotes } from "react-icons/cg";
import SvgUpArrow from "../../../components/svg/uparrow";
import SvgSelectedDownArrow from "../../../components/svg/selecteddownarrow";
import SvgSelectedUpArrow from "../../../components/svg/selecteduparrow";
import SvgDownArrow from "../../../components/svg/downarrow";
import {
  getPhoneNumberByCountryCode,
  validatePhoneNumber,
  formattedMobileNumber,
  getCountryCodefromMobile,
  getMobileNumberCountryCode,
} from "../../../utilities/phonenumberutility";
import { showLocalDateTime } from "../../../utilities/timeutility";
import Linkify from "react-linkify";
import { getEnumLists } from "../../../services/MetadataService";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const LocationContact = () => {

  const {id,name,accounId,accountName} = useParams()
  let locationName = name;
  let locationID = id;
  
  const history = useHistory();
  const [modalRight, setModalRight] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  let [itemsPerPage, setItemsPerPage] = useState();
  const [totalPage, setTotalPage] = useState(1);
  const [size, setSize] = useState();
  const [locations, setLocations] = useState([]);
  const [locationId, setLocationId] = useState();
  const [modalDelete, setModalDelete] = useState(false);
  const [locationContactId, setLocationContactId] = useState("");
  const [locationContactName, setLocationContactName] = useState("");
  const [modalBasic, setModalBasic] = useState(false);
  const [notesAdded, setNotesAdded] = useState("");
  const [notesList, setNotesList] = useState([]);
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortBy, setSortBy] = useState("firstName");
  const [contactId, setContactId] = useState();
  const [selectedNoteId, setSelectedNoteId] = useState();
  const [accountlocationcontactId, setAccountlocationContactId] = useState("");
  const [isSortBySelected, setIsSortBySelected] = useState(false);
  const [location, setLocation] = useState({
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    linkedInUrl: "",
    facebookUrl: "",
    twitterUrl: "",
  });
  const [primaryNumber, setPrimaryNumber] = useState(false);
  const [remote, setRemote] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [hiringTypes, setHiringTypes] = useState([]);
  const [contactHiringType, setContactHiringType] = useState("");
  const [selectedHiringType, setSelectedHiringType] = useState("");

  const [mobileNumber, setMoblieNumber] = useState("");
  const [mobileNumberCountryCode, setMobileNumberCountryCode] = useState("1");
  const [offinceMobileNumber, setOfficeMoblieNumber] = useState("");
  const [officeNumberCountryCode, setOfficeNumberCountryCode] = useState("1");

  const handlePhoneNumber = (value, country) => {
    setPhoneNumber(value);
    if (country != null) {
      let dialCode = country.dialCode;
      let countryCode = country.countryCode;
      let dialCodeLength = dialCode.length;
      let number = value.slice(dialCodeLength).replace(/\D/g, "");
      let mobileNumber = getPhoneNumberByCountryCode(number, countryCode);
      setMobileNumberCountryCode(dialCode);
      setMoblieNumber(mobileNumber);
    }
  };
  const [officeNumber, setOfficeNumber] = useState("");
  const handleOfficeNumber = (value, country) => {
    setOfficeNumber(value);
    if (country != null) {
      let dialCode = country.dialCode;
      let countryCode = country.countryCode;
      let dialCodeLength = dialCode.length;
      let number = value.slice(dialCodeLength).replace(/\D/g, "");
      let mobileNumber = getPhoneNumberByCountryCode(number, countryCode);
      setOfficeNumberCountryCode(dialCode);
      setOfficeMoblieNumber(mobileNumber);
    }
  };

  function handleItemsPerChange(e, key) {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  }
  const getSerialNumber = (index) => {
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }
    return (currentPage - 1) * itemsPerPage + index + 1;
  };

  function onChangePage(e) {
    setCurrentPage(e);
    currentPage(true);
  }

  const [locat, setLocat] = useState({
    // name: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  });
  const Back = () => {
    history.push(`/address/${accounId}/${accountName}`);
  };

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setLocation((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const openLocationDetails = () => {
    setModalRight(true);
    setLocationId("");
    setLocation((prevState) => ({
      ...prevState,
      title: "",
      firstName: "",
      lastName: "",
      email: "",
      linkedInUrl: "",
      facebookUrl: "",
      twitterUrl: "",
    }));
    setPhoneNumber("");
    setOfficeNumber("");
    setPrimaryNumber(false);
    setRemote(false);
    // clearDetails();
    setSelectedHiringType("");

    setMoblieNumber("");
    setMobileNumberCountryCode("1");
    setOfficeMoblieNumber("");
    setOfficeNumberCountryCode("1");
    setContactHiringType("")
  };
  const cancelButton = () => {
    setModalRight(false);
    // clearDetails();
  };
  function handleSearch(e, key) {
    setSearch(e.target.value);
  }

  const sortByJobs = (col) => {
    setIsSortBySelected(true);
    setSortBy(col);
    sortedOrder(col, true);
  };

  const sortedOrder = (col, isSortBySelected) => {
    var select = "";
    if (sortOrder === "desc") {
      setSortOrder("asc");
      select = "asc";
    } else {
      setSortOrder("desc");
      select = "desc";
    }
    getLocations(select, col, currentPage, true);
  };

  useEffect(() => {
    getLocations(sortOrder, sortBy, currentPage, isSortBySelected);
  }, [itemsPerPage, currentPage]);

  useEffect(() => {
    if (!isNullOrEmpty(accountlocationcontactId)) {
      getNotes();
    }
    getJobEnums();
  }, [accountlocationcontactId]);

  const getNotes = () => {
    getLocationContactNotes(locationID, accountlocationcontactId).then(
      (response) => {
        if (response.status === 200) {
          setNotesList(response.data.contactNotes);
        }
      }
    );
  };

  const addJobnotes = () => {
    const addedNotes = notesAdded;
    if (isNullOrEmpty(addedNotes) || !addedNotes.trim().length) {
      toast.error("Please enter notes");
      return;
    }
    const notesObj = {
      commentedById: accountlocationcontactId,
      notes: addedNotes,
    };
    addLocationNotes(notesObj, locationID, accountlocationcontactId).then(
      (response) => {
        if (response.status === 200) {
          toast.success("Notes added successfully");
          getNotes();
          setNotesAdded("");
          return;
        }
      }
    );
    return;
  };

  const getJobEnums = () => {
    getEnumLists().then((response) => {
      if (response !== null) {
        let hiringTypes = response.hiringTypes;
        if (hiringTypes != null) {
          setHiringTypes(hiringTypes);
        }
      }
    });
  };

  const deleteNoteConfirmation = (note) => {
    setSelectedNoteId(note.id);
  };

  const deleteNote = () => {
    deleteLocationContactNotes(
      locationID,
      accountlocationcontactId,
      selectedNoteId
    ).then((response) => {
      try {
        if (response.status === 200) {
          toast.success("Notes deleted successfully");
          getNotes();
          return;
        }
      } catch (err) {
        toast.error("User not authorized");
        console.log("error" + JSON.stringify(err.message));
      }
    });

    return;
  };

  const getLocations = (sortOrder, sortBy, currentPage, isSortBySelected) => {
    setCurrentPage(currentPage);
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }

    if (sessionStorage.getItem("locationContactSortBy") !== null) {
      const sortByValue = sessionStorage.getItem("locationContactSortBy");
      if (!isNullOrEmpty(sortByValue)) {
        if (!isSortBySelected) {
          sortBy = sortByValue;
          setSortBy(sortBy);
        } else {
          sessionStorage.setItem("locationContactSortBy", sortBy);
        }
      } else {
        sessionStorage.setItem("locationContactSortBy", sortBy);
      }
    } else {
      sessionStorage.setItem("locationContactSortBy", sortBy);
    }

    if (sessionStorage.getItem("locationContactSortOrder") !== null) {
      const sortOrderValue = sessionStorage.getItem("locationContactSortOrder");
      if (!isNullOrEmpty(sortOrderValue)) {
        if (!isSortBySelected) {
          sortOrder = sortOrderValue;
          setSortOrder(sortOrder);
        } else {
          sessionStorage.setItem("locationContactSortOrder", sortOrder);
        }
      } else {
        sessionStorage.setItem("locationContactSortOrder", sortOrder);
      }
    } else {
      sessionStorage.setItem("locationContactSortOrder", sortOrder);
    }

    getLocationService(
     
      search,
      itemsPerPage,
      currentPage,
      sortBy,
      sortOrder,
      accounId,
      locationID
    ).then((response) => {
      let size = response.data.size;
      if (size > 0) {
        setSize(size);
      } else {
        setSize(size);
      }
      try {
        if (response.data != null) {
          var locationDetails = response.data;
          if (locationDetails) {
            setLocations(locationDetails.accountContacts);

            const pages = Math.floor(size / itemsPerPage);
            if (Math.round(size % itemsPerPage) > 0) {
              const totalPages = pages + 1;
              setTotalPage(totalPages);
            } else {
              const totalPages = pages;
              setTotalPage(totalPages);
            }
          }
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };

  const handleHiringType = (e) => {
    setSelectedHiringType(e.target.value);
    // setContactHiringType(e.target.value)
    // Get the selected key (if the option has a 'key' attribute, use it; otherwise, use the index)
    const selectedPosition = e.target.selectedIndex;
    if (selectedPosition == 0) {
      setContactHiringType("");
    } else {
      if (hiringTypes.length > 0) {
        let type = hiringTypes[selectedPosition - 1].key;

        setContactHiringType(type);
      }
    }
  };

  const addLocation = (reqObj) => {
    addLocations(reqObj,accounId,locationID).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          toast.success("Contact added successfully");
          getLocations(sortOrder, sortBy, 1);
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };

  const updateLocation = (updateLocationDetails) => {
    updateLocationService(updateLocationDetails, locationId).then(
      (response) => {
        try {
          if (response.message != null) {
            if (response.data.error_message !== "") {
            }
          } else {
            toast.success("Contact updated successfully");
            getLocations(sortOrder, sortBy, 1);
          }
        } catch (err) {
          console.log("message" + JSON.stringify(err.message));
        }
      }
    );
  };

  const updateLocationDetail = (locationdetail) => {
    setModalRight(true);
    setLocationId(locationdetail.id);
    if (locationdetail.title !== null || locationdetail.title !== "") {
      setLocation((prevState) => ({
        ...prevState,
        title: locationdetail.title,
      }));
    }
    if (locationdetail.firstName !== null || locationdetail.firstName !== "") {
      setLocation((prevState) => ({
        ...prevState,
        firstName: locationdetail.firstName,
      }));
    }

    if (locationdetail.lastName !== null || locationdetail.lastName !== "") {
      setLocation((prevState) => ({
        ...prevState,
        lastName: locationdetail.lastName,
      }));
    }

    if (locationdetail.email !== null || locationdetail.email !== "") {
      setLocation((prevState) => ({
        ...prevState,
        email: locationdetail.email,
      }));
    }
    if (
      locationdetail.linkedInUrl !== null ||
      locationdetail.linkedInUrl !== ""
    ) {
      setLocation((prevState) => ({
        ...prevState,
        linkedInUrl: locationdetail.linkedInUrl,
      }));
    }
    if (
      locationdetail.facebookUrl !== null ||
      locationdetail.facebookUrl !== ""
    ) {
      setLocation((prevState) => ({
        ...prevState,
        facebookUrl: locationdetail.facebookUrl,
      }));
    }
    if (
      locationdetail.twitterUrl !== null ||
      locationdetail.twitterUrl !== ""
    ) {
      setLocation((prevState) => ({
        ...prevState,
        twitterUrl: locationdetail.twitterUrl,
      }));
    }

    if (
      locationdetail.mobileNumber !== null ||
      locationdetail.mobileNumber !== ""
    ) {
      setPhoneNumber(locationdetail.mobileNumber);

      let countryCode = getCountryCodefromMobile(locationdetail.mobileNumber);
      setMobileNumberCountryCode(countryCode);

      let mobileNumber = getMobileNumberCountryCode(
        locationdetail.mobileNumber
      );
      setMoblieNumber(mobileNumber);
    }

    if (!isNullOrEmpty(locationdetail.hiringType)) {
      setSelectedHiringType(locationdetail.hiringType.value);
      setContactHiringType(locationdetail.hiringType.key);
    } else {
      setSelectedHiringType("");
      setContactHiringType("");
    }

    if (
      locationdetail.officeNumber !== null ||
      locationdetail.officeNumber !== ""
    ) {
      setOfficeNumber(locationdetail.officeNumber);

      let officeCountryCode = getCountryCodefromMobile(
        locationdetail.officeNumber
      );
      setOfficeNumberCountryCode(officeCountryCode);

      let officeMobileNumber = getMobileNumberCountryCode(
        locationdetail.officeNumber
      );
      setOfficeMoblieNumber(officeMobileNumber);
    }

    setPrimaryNumber(locationdetail.primaryContact);
    setRemote(locationdetail.remote);
  };

  const SubmitButton = () => {
    if (location.firstName === "") {
      toast.error("Please enter firstName");
      return;
    }

    if (location.email !== "") {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(location.email)) {
        toast.error("Please enter valid email");
        return;
      }
    }

    let _mobileNumber = "";
    if (!isNullOrEmpty(mobileNumber)) {
      if (!validatePhoneNumber(mobileNumber, "+" + mobileNumberCountryCode)) {
        toast.error("Please enter valid mobile number");
        return;
      } else {
        _mobileNumber = mobileNumberCountryCode + "-" + mobileNumber;
      }
    }

    let _officeMobileNumber = "";
    if (!isNullOrEmpty(offinceMobileNumber)) {
      if (
        !validatePhoneNumber(offinceMobileNumber, "+" + officeNumberCountryCode)
      ) {
        toast.error("Please enter valid office number");
        return;
      } else {
        _officeMobileNumber =
          officeNumberCountryCode + "-" + offinceMobileNumber;
      }
    }

    if(isNullOrEmpty(contactHiringType)){
      toast.error("Please select hiring type");
      return;
    }

    const reqObj = {
      firstName: location.firstName,
      lastName: location.lastName,
      email: location.email,
      linkedInUrl: location.linkedInUrl,
      facebookUrl: location.facebookUrl,
      twitterUrl: location.twitterUrl,
      hiringType: contactHiringType,
      mobileNumber: _mobileNumber,
      officeNumber: _officeMobileNumber,
      primaryContact: primaryNumber,
      remote: remote,
    };

    if (isNullOrEmpty(locationId)) {
      addLocation(reqObj);
    } else {
      updateLocation(reqObj);
    }
    setModalRight(false);
  };
  const handleDeleteLocation = (deletedId, firstName) => {
    setLocationContactId(deletedId);
    setLocationContactName(firstName);
    setModalDelete(deletedId);
  };
  const deleteContact = () => {
    deleteLocationContactService(locationContactId).then((response) => {
      try {
        if (response.message != null) {
          toast.error("Account in use");
        } else {
          toast.success("Contact deleted successfully");
          let locationSize = locations.length;
          let currentPageSize = currentPage;
          if (locationSize == 1) {
            if (currentPage !== 1) {
              currentPageSize = currentPage - 1;
            }
          }
          setCurrentPage(currentPageSize);
          getLocations(sortOrder, sortBy, 1);
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
      setModalDelete(false);
    });
  };

  const displayPrimaryContact = (location) => {
    return (
      <>
        {location.primaryContact == true ? (
          <>
            <strong className="t-cursor-pointer" title="Primary Number">
              {formattedMobileNumber(location.mobileNumber)}
            </strong>
          </>
        ) : (
          <>{formattedMobileNumber(location.mobileNumber)}</>
        )}
      </>
    );
  };

  const showDeleteButton = (note, indx) => {
    return (
      <Button
        data-toggle="modal"
        data-target="#deleteModal"
        color="primary"
        title="Delete notes"
        className="btn-sm "
        outline
        onClick={() => deleteNoteConfirmation(note)}
      >
        Delete
      </Button>
    );
  };

  const openNoteModel = (id) => {
    setModalBasic(true);
    setAccountlocationContactId(id);
  };
  const showName = (name) => {
    if (!isNullOrEmpty(name)) {
      if (name.includes("null")) {
        let Arr = [];
        Arr = name.split(" ");
        delete Arr[1];
        return Arr[0];
      }
      return name;
    }
  };



  const showHiringType =(hiringType)=>{

    if(!isNullOrEmpty(hiringType)){
  
      if(hiringType.value == "Hiring Manager"){
        return "HM"
      }
      else if (hiringType.value == "Hiring Coordinator"){
        return "HC"
      } else{
        return ""
      }
    }
  
  }

  const showNotesList = (notes) => {
    return (
      <>
        {notes.length > 0 &&
          notes.map((note, index) => {
            return (
              <div key={note.id}>
                <div className="">
                  <span>
                    <div>
                      <div className="row ">
                        <Col className="col-9 p-0">
                          <Col>
                            <span className=" mr-2 font-semibold ">
                              {showName(note.commentedByName)}
                            </span>
                            <div>{showLocalDateTime(note.createdOn)}</div>
                            <div>
                              <Linkify>{note.notes}</Linkify>
                            </div>
                            <Row>
                              <Col> </Col>
                            </Row>
                          </Col>
                        </Col>

                        <Col className="text-right">
                          {showDeleteButton(note)}
                        </Col>
                      </div>
                    </div>
                  </span>
                </div>
                {notes.length > 1 && index != notes.length - 1 && (
                  <>
                    <hr />
                  </>
                )}
              </div>
            );
          })}
      </>
    );
  };

  return (
    <>
      <Row>
        <Colxx xxs="12">
          <Card className="mt-2">
            {
              <Row>
                <Colxx xxs="12">
                  <div>
                    <CardHeader>
                      <div className="row">
                        <Colxx sm={10} style={{ padding: 0 }}>
                          <div className="col">
                            <div className=" ml-3">
                              <h3 className="mt-2">
                                <b>{accountName}</b> | <b>{locationName}</b> |
                                Location Contacts
                              </h3>
                            </div>
                          </div>
                        </Colxx>
                        <Colxx sm={2}>
                          <div className="btn-group float-right">
                            <Button
                              outline
                              size="sm"
                              color="primary"
                              onClick={Back}
                            >
                              Back
                            </Button>

                            <Button
                              color="primary"
                              className=""
                              size="sm"
                              outline
                              onClick={openLocationDetails}
                            >
                              Add
                            </Button>
                          </div>
                        </Colxx>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <Colxx className="mb-4">
                        <Row className="mt-2">
                          <Colxx sm={4} style={{ padding: 0 }}>
                            <InputGroup>
                              <Input
                                type=""
                                name=""
                                placeholder="Search"
                                onChange={handleSearch}
                                value={search}
                                className="form-control"
                              ></Input>
                              <InputGroupAddon addonType="append">
                                <Button
                                  outline
                                  color="primary"
                                  onClick={(e) =>
                                    getLocations(sortOrder, sortBy, 1)
                                  }
                                >
                                  Search
                                </Button>
                              </InputGroupAddon>
                            </InputGroup>
                          </Colxx>
                          <Colxx sm={4}></Colxx>
                          <Colxx sm={4} className="address_page">
                            <Input
                              type="select"
                              value={itemsPerPage}
                              onChange={handleItemsPerChange}
                            >
                              <option value={""}>Items Per Page</option>
                              <option value={"10"}>10</option>
                              <option value={"25"}>25</option>
                              <option value={"50"}>50</option>
                              <option value={"100"}>100</option>
                            </Input>
                          </Colxx>
                        </Row>
                      </Colxx>
                      <Modal
                        className="t-W-500"
                        isOpen={Boolean(modalRight)}
                        toggle={() => setModalRight(!modalRight)}
                        wrapClassName="modal-right"
                      >
                        <Row>
                          <Colxx xxs="12">
                            <Card>
                              <CardBody>
                                <CardTitle>
                                  {locationId === "" ? (
                                    <strong>Add Location Contact</strong>
                                  ) : (
                                    <strong>Update Location Contact</strong>
                                  )}
                                </CardTitle>
                                <Form>
                                  <FormGroup row>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>First Name*</Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="firstName"
                                          name="firstName"
                                          data-testid="location-name"
                                          onChange={inputsHandler}
                                          value={location.firstName}
                                        >
                                          <span className="required-star"></span>
                                        </Input>
                                      </FormGroup>
                                    </Colxx>

                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>Last Name</Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="lastName"
                                          name="lastName"
                                          data-testid="location-name"
                                          onChange={inputsHandler}
                                          value={location.lastName}
                                        >
                                          <span className="required-star"></span>
                                        </Input>
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>Email</Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="email"
                                          name="email"
                                          data-testid="email"
                                          onChange={inputsHandler}
                                          value={location.email}
                                        />
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>
                                          Title
                                          {/* <span className="required-star"></span> */}
                                        </Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="title"
                                          name="title"
                                          data-testid="location-title"
                                          onChange={inputsHandler}
                                          value={location.title}
                                          // placeholder={"firstName"}
                                        ></Input>
                                      </FormGroup>
                                    </Colxx>

                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>Mobile Number</Label>
                                        <PhoneInput
                                          country="us"
                                          countryCodeEditable={false}
                                          type="text"
                                          name="phoneNumber"
                                          data-testid="location-phoneNumber"
                                          onChange={handlePhoneNumber}
                                          value={phoneNumber}
                                        />
                                      </FormGroup>
                                    </Colxx>

                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>Office Number</Label>
                                        <PhoneInput
                                          country="us"
                                          countryCodeEditable={false}
                                          type="text"
                                          name="phoneNumber"
                                          data-testid="location-phoneNumber"
                                          onChange={handleOfficeNumber}
                                          value={officeNumber}
                                        />
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>LinkedInUrl</Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="linkedInUrl"
                                          name="linkedInUrl"
                                          data-testid="location-title"
                                          onChange={inputsHandler}
                                          value={location.linkedInUrl}
                                        ></Input>
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={6}>
                                      <FormGroup>
                                        <Label>FacebookUrl</Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="facebookUrl"
                                          name="facebookUrl"
                                          data-testid="location-facebookUrl"
                                          onChange={inputsHandler}
                                          value={location.facebookUrl}
                                        ></Input>
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={12}>
                                      <FormGroup>
                                        <Label>TwitterUrl</Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="twitterUrl"
                                          name="twitterUrl"
                                          data-testid="location-twitterUrl"
                                          onChange={inputsHandler}
                                          value={location.twitterUrl}
                                        ></Input>
                                      </FormGroup>
                                    </Colxx>

                                    <Colxx sm={12}>
                                      <FormGroup>
                                        <Label>Hiring Type</Label>
                                        <Input
                                          className="t-rounded-lg"
                                          type="select"
                                          name="hiringtype"
                                          defaultValue={"Select hiring type"}
                                          data-testid="location-hiringtype"
                                          onChange={handleHiringType}
                                          value={selectedHiringType}
                                        >
                                          <option value="Select Hiring Type">
                                            Select hiring type
                                          </option>
                                          {hiringTypes.length > 0 &&
                                            hiringTypes.map((types) => {
                                              return (
                                                <option
                                                  key={types.key}
                                                  value={types.value}
                                                >
                                                  {types.value}
                                                </option>
                                              );
                                            })}
                                        </Input>
                                      </FormGroup>
                                    </Colxx>

                                    <Colxx sm={12}>
                                      <FormGroup>
                                        <Label>
                                          <input
                                            data-testid="account-termsAndConditions"
                                            type="checkbox"
                                            className="inputterm"
                                            checked={primaryNumber}
                                            onChange={(e) =>
                                              setPrimaryNumber(e.target.checked)
                                            }
                                          />
                                          Primary Contact
                                        </Label>
                                      </FormGroup>
                                    </Colxx>
                                    <Colxx sm={12}>
                                      <FormGroup>
                                        <Label>
                                          <input
                                            data-testid="account-remote"
                                            type="checkbox"
                                            className="inputterm"
                                            checked={remote}
                                            onChange={(e) =>
                                              setRemote(e.target.checked)
                                            }
                                          />
                                          Remote
                                        </Label>
                                      </FormGroup>
                                    </Colxx>
                                  </FormGroup>

                                  <FormGroup row>
                                    <Colxx sm={12}></Colxx>
                                  </FormGroup>
                                  <FormGroup>
                                    <Colxx sm={12}></Colxx>
                                  </FormGroup>
                                </Form>
                              </CardBody>
                            </Card>
                          </Colxx>
                        </Row>

                        <ModalFooter className="model-button modal-bottom-location">
                          <Button
                            color="primary"
                            size="sm"
                            outline
                            className="mt-4"
                            onClick={SubmitButton}
                          >
                            Save
                          </Button>

                          <Button
                            color="primary"
                            size="sm"
                            outline
                            className=" mt-4 ml-1"
                            onClick={cancelButton}
                          >
                            Cancel
                          </Button>
                        </ModalFooter>
                      </Modal>
                      <Colxx sm={12} className="mt-2 location-table">
                        <div>
                          <div className="tableContainer">
                            <div className="tablewrapper">
                              <Table className=" hms_table jobRequisition_table table-responsive ">
                                <thead>
                                  <tr>
                                    <th className="w-10">S.No</th>
                                    <th
                                      onClick={() => sortByJobs("firstName")}
                                      className="w-15"
                                    >
                                      <Row className="w-[150]">
                                        {" "}
                                        <div className="col-8 pr-1 t-cursor-pointer">
                                          {" "}
                                          First Name{" "}
                                        </div>
                                        <div className="col">
                                          {sortBy == "firstName" ? (
                                            <>
                                              {" "}
                                              {sortBy === "firstName" ? (
                                                sortOrder === "asc" ? (
                                                  <>
                                                    <Row>
                                                      <SvgSelectedUpArrow />
                                                    </Row>
                                                    <Row>
                                                      <SvgDownArrow />
                                                    </Row>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Row>
                                                      <SvgUpArrow />
                                                    </Row>
                                                    <Row>
                                                      {" "}
                                                      <SvgSelectedDownArrow />
                                                    </Row>
                                                  </>
                                                )
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {" "}
                                              <Row>
                                                <SvgUpArrow />
                                              </Row>
                                              <Row>
                                                <SvgDownArrow />
                                              </Row>
                                            </>
                                          )}
                                        </div>
                                      </Row>
                                    </th>
                                    <th
                                      onClick={() => sortByJobs("lastName")}
                                      className="w-15"
                                    >
                                      <Row className="w-[150]">
                                        {" "}
                                        <div className="col-8 pr-1 t-cursor-pointer">
                                          {" "}
                                          Last Name{" "}
                                        </div>
                                        <div className="col">
                                          {sortBy == "lastName" ? (
                                            <>
                                              {" "}
                                              {sortBy === "lastName" ? (
                                                sortOrder === "asc" ? (
                                                  <>
                                                    <Row>
                                                      <SvgSelectedUpArrow />
                                                    </Row>
                                                    <Row>
                                                      <SvgDownArrow />
                                                    </Row>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Row>
                                                      <SvgUpArrow />
                                                    </Row>
                                                    <Row>
                                                      {" "}
                                                      <SvgSelectedDownArrow />
                                                    </Row>
                                                  </>
                                                )
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {" "}
                                              <Row>
                                                <SvgUpArrow />
                                              </Row>
                                              <Row>
                                                <SvgDownArrow />
                                              </Row>
                                            </>
                                          )}
                                        </div>
                                      </Row>
                                    </th>
                                    <th
                                      onClick={() => sortByJobs("email")}
                                      className="w-15"
                                    >
                                      <Row className="w-[200]">
                                        {" "}
                                        <div className="col pr-1 t-cursor-pointer">
                                          {" "}
                                          E-mail{" "}
                                        </div>
                                        <div className="col">
                                          {sortBy === "email" ? (
                                            <>
                                              {sortBy === "email" ? (
                                                sortOrder === "asc" ? (
                                                  <>
                                                    {" "}
                                                    <Row>
                                                      <SvgSelectedUpArrow />
                                                    </Row>
                                                    <Row>
                                                      <SvgDownArrow />
                                                    </Row>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Row>
                                                      <SvgUpArrow />
                                                    </Row>
                                                    <Row>
                                                      {" "}
                                                      <SvgSelectedDownArrow />
                                                    </Row>
                                                  </>
                                                )
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {" "}
                                              <Row>
                                                <SvgUpArrow />
                                              </Row>
                                              <Row>
                                                <SvgDownArrow />
                                              </Row>
                                            </>
                                          )}
                                        </div>
                                      </Row>
                                    </th>
                                    <th className="w-15">Role</th>

                                    <th className="w-15">Title</th>

                                    <th
                                      onClick={() => sortByJobs("remote")}
                                      className="w-10"
                                    >
                                      <Row className="w-[100]">
                                        {" "}
                                        <div className="col pr-1 t-cursor-pointer">
                                          Remote
                                        </div>
                                        <div className="col">
                                          {sortBy === "remote" ? (
                                            <>
                                              {" "}
                                              {sortBy === "remote" ? (
                                                sortOrder === "asc" ? (
                                                  <>
                                                    <Row>
                                                      <SvgSelectedUpArrow />
                                                    </Row>
                                                    <Row>
                                                      <SvgDownArrow />
                                                    </Row>
                                                  </>
                                                ) : (
                                                  <>
                                                    <Row>
                                                      <SvgUpArrow />
                                                    </Row>
                                                    <Row>
                                                      {" "}
                                                      <SvgSelectedDownArrow />
                                                    </Row>
                                                  </>
                                                )
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {" "}
                                              <Row>
                                                <SvgUpArrow />
                                              </Row>
                                              <Row>
                                                <SvgDownArrow />
                                              </Row>
                                            </>
                                          )}
                                        </div>
                                      </Row>
                                    </th>
                                    <th className="w-15">Mobile Number</th>
                                    <th className="w-15">Office Number</th>

                                    <th className="w-20">Actions</th>
                                  </tr>
                                </thead>
                                {locations.length > 0 ? (
                                  locations.map((location, index) => {
                                    return (
                                        <tbody key={index}>
                                          <tr>
                                            <td className="w-[60]">
                                              {location.primaryContact ==
                                              true ? (
                                                <>
                                                  <strong
                                                    className="t-cursor-pointer"
                                                    title="Primary Contact"
                                                  >
                                                    {getSerialNumber(index)}
                                                  </strong>
                                                </>
                                              ) : (
                                                <> {getSerialNumber(index)}</>
                                              )}
                                            </td>
                                            <td className="w-[120]">
                                              <u>
                                                <span
                                                  className="text-dark t-cursor-pointer"
                                                  onClick={() => {
                                                    updateLocationDetail(
                                                      location
                                                    );
                                                  }}
                                                  title="Edit Contact"
                                                >
                                                  {location.primaryContact ==
                                                  true ? (
                                                    <>
                                                      <strong
                                                        className="t-cursor-pointer"
                                                        title="Primary Contact"
                                                      >
                                                        {location.firstName}
                                                      </strong>
                                                    </>
                                                  ) : (
                                                    <> {location.firstName}</>
                                                  )}
                                                </span>
                                              </u>
                                            </td>
                                            <td className="w-[120]">
                                              {location.primaryContact ==
                                              true ? (
                                                <>
                                                  <strong
                                                    className="t-cursor-pointer"
                                                    title="Primary Contact"
                                                  >
                                                    {location.lastName}
                                                  </strong>
                                                </>
                                              ) : (
                                                <> {location.lastName}</>
                                              )}
                                            </td>
                                            <td className="w-[180]">
                                              {location.primaryContact ==
                                              true ? (
                                                <>
                                                  <strong
                                                    className="t-cursor-pointer"
                                                    title="Primary Contact"
                                                  >
                                                    {location.email}
                                                  </strong>
                                                </>
                                              ) : (
                                                <>{location.email}</>
                                              )}
                                            </td>
                                            <td className="w-[60]">

{showHiringType(location.hiringType)}  

</td>
                                            <td className="w-[120]">
                                              {location.title}
                                            </td>
                                            <td className="w-[120]">
                                              {location.remote == true ? (
                                                <>
                                                  <strong
                                                    className="t-cursor-pointer ml-3"
                                                    title="Primary Contact "
                                                  >
                                                    <input
                                                      className=""
                                                      type="checkbox"
                                                      defaultChecked={true}
                                                    />
                                                  </strong>
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </td>
                                            <td className="w-[120]">
                                              {displayPrimaryContact(location)}
                                            </td>

                                           

                                            <td className="w-[120]">
                                              {location.primaryContact ==
                                              true ? (
                                                <>
                                                  <strong
                                                    className="t-cursor-pointer"
                                                    title="Primary Contact"
                                                  >
                                                    {formattedMobileNumber(
                                                      location.officeNumber
                                                    )}
                                                  </strong>
                                                </>
                                              ) : (
                                                <>
                                                  {formattedMobileNumber(
                                                    location.officeNumber
                                                  )}
                                                </>
                                              )}
                                            </td>

                                            <td className="w-[0]">
                                              <>
                                                <div className="actionbutton flex center">
                                                  <>
                                                    <CgNotes
                                                      title="Location Notes"
                                                      className="ic-profile text-dark delete-icon ml-2  emp_icon t-cursor-pointer"
                                                      onClick={() =>
                                                        openNoteModel(
                                                          location.id
                                                        )
                                                      }
                                                    />

                                                    <i
                                                      title="Delete Contact"
                                                      className="simple-icon-trash ic-profile text-dark delete-icon ml-2 emp_icon t-cursor-pointer"
                                                      onClick={() =>
                                                        handleDeleteLocation(
                                                          location.id,
                                                          location.firstName
                                                        )
                                                      }
                                                    />
                                                    {location.primaryContact ==
                                                    true ? (
                                                      <span title="Primary Contact">
                                                        <svg
                                                          xmlns="http://www.w3.org/2000/svg"
                                                          fill="#FFA500"
                                                          viewBox="0 0 576 512"
                                                          className="ml-2 mb-1"
                                                        >
                                                          <path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
                                                        </svg>
                                                      </span>
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </>
                                                </div>
                                              </>
                                            </td>
                                          </tr>
                                        </tbody>
                                    );
                                  })
                                ) : (
                                  <tfoot></tfoot>
                                )}
                              </Table>
                            </div>
                          </div>
                          {locations == "" || locations == null ? (
                            <>
                              {" "}
                              <p className="nodata-text">
                                No location contacts available
                              </p>
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </Colxx>
                      <hr></hr>
                      <Pagination
                        currentPage={currentPage}
                        totalPage={totalPage}
                        numberLimit={5}
                        firstIsActive={true}
                        onChangePage={(e) => onChangePage(e)}
                      />{" "}
                      <h3> Total matching records : {size} </h3>
                    </CardBody>
                  </div>
                </Colxx>

                <Separator className="mt-5 mb-5"></Separator>
              </Row>
            }
          </Card>
        </Colxx>
      </Row>

      <Modal isOpen={Boolean(modalDelete)} toggle={() => setModalDelete(!modalDelete)}>
        <ModalBody>
          Do you want to delete location contact{" "}
          <strong> {locationContactName}</strong>?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalDelete(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            size="sm"
            outline
            onClick={(e) => {
              deleteContact();
            }}
          >
            Delete
          </Button>
        </ModalFooter>
      </Modal>
      <div
        className="modal fade mt-5 t-z-Index"
        id="deleteModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <h3>Do you want to delete notes?</h3>
            </div>

            <div className="modal-footer p-3">
              <Button
                type="button"
                color="primary"
                size="sm"
                outline
                data-dismiss="modal"
              >
                Close
              </Button>
              <Button
                type="button"
                color="primary"
                size="sm"
                outline
                data-dismiss="modal"
                onClick={() => {
                  deleteNote();
                }}
              >
                Delete
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        className="mt-5"
        isOpen={Boolean(modalBasic)}
        toggle={() => setModalBasic(!modalBasic)}
      >
        <ModalHeader>
          <strong>ADD NOTES</strong>
        </ModalHeader>
        <ModalBody>
          <Input
            rows="4"
            id="notes"
            type="textarea"
            maxLength="255"
            name="notes"
            placeholder={"Enter notes..."}
            onChange={(e) => setNotesAdded(e.target.value)}
            value={notesAdded}
          />

          <Button
            className="mt-2 mb-4"
            color="primary"
            size="sm"
            outline
            onClick={addJobnotes}
          >
            Add Notes
          </Button>
          {showNotesList(notesList)}
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            outline
            color="primary"
            size="sm"
            onClick={() => setModalBasic(false)}
          >
            Done
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default LocationContact;
